let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cMURs")).then(() => parcelRequire('9tlLm'));